export function requestLogin(body) {
	return {
		type: '@auth/REQUEST_LOGIN',
		payload: { body },
	};
}

export function requestLoginMaster(body) {
	return {
		type: '@auth/REQUEST_LOGIN_MASTER',
		payload: { body },
	};
}

export function successLogin(dados) {
	return {
		type: '@auth/SUCCESS_LOGIN',
		payload: { dados },
	};
}

export function failureLogin(error) {
	return {
		type: '@auth/FAILURE_LOGIN',
		payload: { error },
	};
}

export function requestResetPass(body) {
	return {
		type: '@auth/REQUEST_RESETPASS',
		payload: { body },
	};
}

export function requestAlterarSenha(body) {
	return {
		type: '@auth/REQUEST_ALTERAR_SENHA',
		payload: { body },
	};
}

export function requestAlterarSenhaToken(body) {
	return {
		type: '@auth/REQUEST_ALTERAR_SENHA_TOKEN',
		payload: { body },
	};
}

export function requestTokenDev() {
	return {
		type: '@auth/REQUEST_TOKEN_DEV',
	};
}

export function successTokenDev(token) {
	return {
		type: '@auth/SUCCESS_TOKEN_DEV',
		payload: { token },
	};
}

export function failureTokenDev(error) {
	return {
		type: '@auth/FAILURE_TOKEN_DEV',
		payload: { error },
	};
}

export function signOut(user) {
	return {
		type: '@auth/SIGNOUT',
		payload: {user}
	};
}

export function successTokenV1(dados) {
	return {
		type: '@auth/SUCCESS_TOKEN_V1',
		payload: { dados },
	};
}

export function failedTokenV1(erro) {
	return {
		type: '@auth/FAILED_TOKEN_V1',
		payload: { erro },
	};
}

